import { z } from 'zod';

// Import variables
import { POSTAL_CODES_REGEX, VAT_NUMBER_REGEX, INVOICE_TYPES } from 'helpers/variables';

// Import types
import type { InvoiceInfoType } from 'types/api/invoice';

export const defaultValues = {
	type: INVOICE_TYPES.BUSINESS,
	firstname: '',
	lastname: '',
	company_name: '',
	vat_number: '',
	street: '',
	building: '',
	apartment: '',
	city: '',
	zip: ''
};

export const schema = z
	.object({
		need_invoice: z.boolean(),
		client: z.object({
			type: z.string(),
			firstname: z.string().trim().optional(),
			lastname: z.string().trim().optional(),
			company_name: z.string().trim().optional(),
			vat_number: z.string().trim().optional(),
			street: z.string().trim().min(1, { message: 'payment:street_required' }),
			building: z.string().trim().min(1, { message: 'payment:building_required' }),
			city: z.string().trim().min(1, { message: 'payment:city_required' }),
			apartment: z.string().trim().optional(),
			zip: z.string().trim().min(1, { message: 'payment:zip_required' }).regex(POSTAL_CODES_REGEX.POLAND, 'payment:zip_valid')
		})
	})
	.superRefine(({ client }, ctx) => {
		if (client.type === INVOICE_TYPES.BUSINESS) {
			if (!client.company_name) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['client.company_name'],
					message: 'payment:company_name_required'
				});
			}

			if (!client.vat_number) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['client.vat_number'],
					message: 'payment:vat_number_required'
				});
			} else if (!VAT_NUMBER_REGEX.test(client.vat_number)) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['client.vat_number'],
					message: 'payment:vat_number_valid'
				});
			}
		}

		if (client.type === INVOICE_TYPES.INDIVIDUAL) {
			if (!client.firstname) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['client.firstname'],
					message: 'payment:firstname_required'
				});
			}

			if (!client.lastname) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					path: ['client.lastname'],
					message: 'payment:lastname_required'
				});
			}
		}

		return z.NEVER;
	});

export type InvoiceFormValues = {
	need_invoice: boolean;
	client: InvoiceInfoType;
};
